import Datetime from "react-datetime";
import { Dropdown, Form, Input } from "semantic-ui-react";

export const dateOperatorOptions = [
  {
    key: 1,
    text: "Exactly",
    value: {
      context: "date",
      value: "exactly",
      name: "filter_operator",
      next_operand: "filter_operand2",
      group: "dateOperatorOptions",
    },
  },
  {
    key: 2,
    text: "Between",
    value: {
      context: "date_range",
      value: "between",
      name: "filter_operator",
      next_operand: "filter_operand2",
      group: "dateOperatorOptions",
    },
  },
  {
    key: 3,
    text: "Before",
    value: {
      context: "date",
      value: "before",
      name: "filter_operator",
      next_operand: "filter_operand2",
      group: "dateOperatorOptions",
    },
  },
  {
    key: 4,
    text: "After",
    value: {
      context: "date",
      name: "filter_operator",
      value: "after",
      next_operand: "filter_operand2",
      group: "dateOperatorOptions",
    },
  },
  {
    key: 5,
    text: "Is",
    value: {
      context: "is",
      name: "filter_operator",
      value: "is",
      next_operand: "filter_operand2",
      group: "dateOperatorOptions",
    },
  },
];

export const nullOptions = [
  { key: 1, text: "Null", value: "NULL" },
  { key: 2, text: "Not Null", value: "NOT NULL" },
];

export const SingleDatePicker = ({
  value,
  onChange,
  placeholder = "Date",
  iconSize = "",
}) => (
  <div style={{ width: 180 }}>
    <Datetime
      closeOnSelect={true}
      onChange={onChange}
      value={value}
      inputProps={{ placeholder, readOnly: true }}
      dateFormat={"YYYY-MM-DD"}
      timeFormat={false}
      renderInput={props => (
        <Input
          icon={`${iconSize} calendar outline`.trim()}
          style={{
            width: 180,
          }}
          {...props}
        />
      )}
    />
  </div>
);

export const DateRangePickers = ({ from, to, onFromChange, onToChange }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 14,
      paddingRight: 14,
    }}
  >
    <SingleDatePicker value={from} onChange={onFromChange} placeholder="From" />

    <SingleDatePicker value={to} onChange={onToChange} placeholder="To" />
  </div>
);

export const NullSelector = ({ value, onChange, name = "filter_operand2" }) => (
  <Dropdown
    placeholder="Filter By"
    selection
    fluid
    name={name}
    options={nullOptions}
    value={value}
    onChange={onChange}
  />
);
